import React from 'react';
import PropTypes from 'prop-types';
import { Label } from '@americanexpress/dls-react';
import { IconCalendar } from '@americanexpress/dls-icons';
import { useIsHomePageVariantHook } from '../../hooks/useIsHomePageVariantHook';

const DateInputLabel = ({ inputID, labelID, labelText }) => {
  const isVariant = useIsHomePageVariantHook();
  if (isVariant) {
    return (
      <div className="flex flex-align-center margin-1-b">
        <Label id={labelID} htmlFor={inputID} tabIndex="-1">
          {labelText}
        </Label>
      </div>
    );
  }
  return (
    <div className="flex flex-align-center">
      <IconCalendar color="neutral" size="sm" role="presentation" />
      <label
        id={labelID}
        htmlFor={inputID}
        tabIndex="-1"
        className="body color-text-subtle margin-0"
      >
        {labelText}
      </label>
    </div>
  );
};

DateInputLabel.propTypes = {
  inputID: PropTypes.string.isRequired,
  labelID: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
};

export default DateInputLabel;
